import React from 'react';

import './loader.css';

export default({ show, message = '' }) => (
    <section className={ `loading-pop-screen ${ show ? 'show' : '' }` }>
        <div className='loader-container'>
            <div className='loader-icon' />
            { message !== '' && <div className='message-wrapper'>{ message }</div>}
        </div>
    </section>
);



// WEBPACK FOOTER //
// ./src/components/loader-component/loader.js